import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Ostukorvi summa

  <span style="color:#85c1dc;">**FI:**</span>
  Ostoskorin summa

  <span style="color:#85c1dc;">**RU:**</span>
  Сумма корзины
*/
/* @__NO_SIDE_EFFECTS__ */
const m1729 = msg(
  mf`Ostukorvi summa`,
  mf`Ostoskorin summa`,
  mf`Сумма корзины`,
)

export { m1729 as 'w.basket.summary.total_price' }